import styleSource from "./style.css?inline";

export function Style() {
  return <style>{styleSource}</style>;
}
